<script lang="ts" setup>
import { useXrayChatMode } from '~/composables/unified/DevPanel/useXrayChatMode';

const { isXrayChat, setXrayChat } = useXrayChatMode();
</script>

<template>
  <div class="px-3 py-1">
    <div class="grid grid-cols-2 gap-1.5">
      <button
        class="rounded-md px-2 py-0.5 text-xs font-medium"
        :class="isXrayChat ? 'bg-muted text-muted-foreground hover:bg-accent' : 'bg-primary text-primary-foreground hover:brightness-90'"
        @click="setXrayChat(false)"
      >
        Normal chat
      </button>
      <button
        class="rounded-md px-2 py-0.5 text-xs font-medium"
        :class="isXrayChat ? 'bg-primary text-primary-foreground hover:brightness-90' : 'bg-muted text-muted-foreground hover:bg-accent'"
        @click="setXrayChat(true)"
      >
        X-ray chat
      </button>
    </div>
    <p class="mt-1 text-xs text-muted-foreground">
      The x-ray swaps the coach surface for the build harness on the same session.
    </p>
  </div>
</template>
